import React, { useEffect, useRef, useState } from "react";
import "./Ready_to_Explore.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Demo_Modal from "../../common/demo-modal/Demo_Modal";

const Ready_to_Explore = () => {
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("active");
        } else {
          sectionRef.current.classList.remove("active");
        }
      },
      {
        threshold: 0.5,
      },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  return (
    <>
      <section className="Ready_to_Explore">
        <div className="container">
          <div className="Ready_to_Explore_div" ref={sectionRef}>
            <div className="ready_title_holder">
              <h2 className="ready_title">Ready to Explore</h2>
            </div>

            <div className="ready_content_holder">
              <div className="audio_title_holder">
                <h2 className="audio_title">Audio Meet?</h2>
                <p className="audio_subtitle">
                  See how our platform works and how it fits your business
                  needs—live with our experts.
                </p>
              </div>
              <p className="audio_text">
                Schedule a free demo and see how we can transform your workflow.
              </p>

              <Common_Btn text="Book Your Demo" onClick={handleOpenModal} />
            </div>
          </div>
        </div>
      </section>

      <Demo_Modal show={showModal} handleClose={handleCloseModal} />
    </>
  );
};

export default Ready_to_Explore;
